<template>

  <component :is="wrappingElement" :aria-label="category[nameKey]" :class="`${isActiveItem ? 'active_category': 'group '}`"
             :to="wrappingElement ? formatCategoryLink(category) : undefined"
             @click="onItemClick"
             @touchstart="onTouchStart"
             @touchend="onTouchEnd"
  >
    <div
        :class="`flex category__slider__item h-full max-h-[180px] md:max-h-[200px] cursor-pointer flex-col py-0 px-0.5 w-[6.25rem] md:w-[7.5rem] mx-auto sm:mx-0.5 md:mx-1 text-center items-center justify-center active:border-black/30`">
      <!-- category image -->
      <div
          :class="`${designId == 2 ? 'h-[3.2rem] w-[3.2rem] lg:w-[3.5rem] lg:h-[3.5rem] xl:w-[3.8rem] xl:h-[3.8rem] 3xl:w-[4.8rem] 3xl:h-[4.8rem]' : ' h-[4.8rem] w-[4.8rem] lg:w-[5.5rem] lg:h-[5.5rem] xl:w-[5.9rem] xl:h-[5.9rem] 3xl:w-[6.5rem] 3xl:h-[6.5rem]' } image-container flex justify-center items-center mb-2 p-0 border border-light-1 box-border select-none rounded-[50%] overflow-hidden`.trim()">
        <img
            :src="category.image || defaultImg"
            :alt="''"
            :width="designId == 2 ? 76 : 96"
            :height="designId == 2 ? 76 : 96"
            loading="eager"
            class="w-[94%] h-[94%] rounded-full object-cover bg-gray-100"
            @error="(e) => { e.target.src = defaultImg; }"
            draggable="false"
        />

      </div>
      <!-- category name -->
      <div :title="category[nameKey]" class="inline-flex flex-nowrap items-center gap-2 shrink-1 min-w-0">
                <span
                    :class="`${designId == 2 ? 'text-[0.57rem] md:text-[0.653rem] 3xl:text-[0.75rem]' : 'text-[0.75rem] md:text-[0.8rem] lg:text-[0.84rem] 3xl:text-[0.865rem]'} md:group-hover:text-primary category_name transition-colors duration-200 ellipsis-x2 text-center font-bold mt-1 mb-0 break-words text-black`.trim()">{{
                    category[nameKey]
                  }}</span>
      </div>
    </div>
  </component>
</template>

<script>
import defaultImg from "@/assets/icons/cezma_default_icon.png";
import {onImageError, ROUTESNAMES} from "@/helpers";
import {NuxtLink} from '#components';

export default {
  data() {
    return {
      defaultImg
    }
  },
  props: {
    category: {
      type: Object,
      required: true,
      default: () => ({})
    },
    asLink: {
      type: Boolean,
      required: false,
      default: true
    },
    selectedItemId: {
      type: [String, Number],
      required: false,
      default: ""
    },
    designId: {
      type: [String, Number],
      required: false,
      default: 1
    },
  },
  computed: {
    wrappingElement() {
      return this.asLink ? NuxtLink : 'div';
    },
    isActiveItem() {
      const {selectedItemId, category} = this;
      return selectedItemId && (selectedItemId == category.id)
    },
  },
  methods: {
    onImageError,
    formatCategoryLink(category) {
      if (category?.link) {
        return category?.link;
      } else {
        let queryToUrl = `${(category?.id !== "more" && `&main_category_id=${category?.id}`) || ""
        }${`&from=list`}`.replace(/^&/, "");
        let encodedQuery = btoa(encodeURIComponent(queryToUrl));
        return `${ROUTESNAMES.user.products}?${encodedQuery}`;
      }
    },
    onItemClick() {
      this.$emit("itemClick", this.category);
    },
    onTouchStart(e) {
      // Add visual feedback for touch
      e.currentTarget.style.transform = 'scale(0.98)';
    },
    onTouchEnd(e) {
      // Remove visual feedback
      e.currentTarget.style.transform = 'scale(1)';
    }
  }
}
</script>

<style lang="scss" scoped>
.active_category {
  .category_name {
    color: var(--primary-lighter-clr);
  }
}

/* Mobile-specific improvements for touch interaction */
@media (max-width: 1024px) {
  .category__slider__item {
    /* Ensure proper touch target size */
    min-height: 44px;
    min-width: 44px;
    
    /* Improve touch interaction */
    -webkit-tap-highlight-color: rgba(0,0,0,0.1);
    touch-action: manipulation;
    cursor: pointer;
    
    /* Better visual feedback */
    transition: all 0.15s ease;
    
    /* Ensure clickability */
    pointer-events: auto;
    position: relative;
    z-index: 10;
  }
  
  /* Touch feedback */
  .category__slider__item:active {
    transform: scale(0.98);
    transition: transform 0.1s ease;
  }
  
  /* Ensure images and text are clickable */
  .image-container {
    pointer-events: auto;
    cursor: pointer;
    /* GPU acceleration for smoother rendering */
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    will-change: transform;
  }
  
  .image-container img {
    /* Optimize image rendering during slider movement */
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    backface-visibility: visible;
    -webkit-backface-visibility: visible;
  }
  
  .category_name {
    pointer-events: auto;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0.1);
  }
  
  /* Improve touch area */
  .image-container,
  .category_name {
    min-height: 44px;
    min-width: 44px;
  }
}
</style>